import React, { memo } from 'react';
import { LazyComponent, useSellerData, SellerPageFederatedSeller } from '@fiverr-private/seller_pages_toolbox';

const lazyImport = () => import(/* webpackChunkName: 'NotableClients' */ './RolePageClientsResolver');

export const LazyRolePageClients = memo((props) => {
    const { notableClients } = useSellerData(selectSellerSlice);
    const shouldRenderNotableClients = notableClients.length > 0;

    return (
        <LazyComponent
            moduleName="NotableClients"
            lazyImport={lazyImport}
            componentProps={props}
            shouldImport={shouldRenderNotableClients}
        />
    );
});

LazyRolePageClients.displayName = 'LazyRolePageClients';

const selectSellerSlice = (seller: SellerPageFederatedSeller) => ({
    notableClients: seller.notableClients,
});
